import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import FullPageLayout from '../../../../components/FullPageLayout';
import ShopriteCard from '../../../../components/ShopriteCard';
import LegalLinks from '../../../../components/LegalLinks';
import CloseAccountPage from '../../components/CloseAccountPage';
import ProgressCircles from '../../components/ProgressCircles';
import CardBalance from '../../components/CardBalance';
import LoyaltyButton from '../../components/LoyaltyButton';
import HowDoesThisWorkPopUp from '../../components/HowDoesThisWorkPopUp';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import {logAmplitudeAccountScreen} from "../../../../amplitude";

class AddCouponPage extends Component {

  static propTypes = {
    isBalanceLoaded: PropTypes.bool.isRequired,
    cardNumber: PropTypes.string.isRequired,
    bufferAmount: PropTypes.number.isRequired,
    goalAmount: PropTypes.number.isRequired,
    addBtnDisabled: PropTypes.bool.isRequired,
    onAddBtnClick: PropTypes.func.isRequired,
    isPopupOpen: PropTypes.bool.isRequired,
    onTogglePopup: PropTypes.func.isRequired,
  }

    componentDidMount() {
      logAmplitudeAccountScreen()
    }

  render() {
    const {
      isBalanceLoaded,
      cardNumber,
      bufferAmount,
      goalAmount,
      addBtnDisabled,
      onAddBtnClick,
      isPopupOpen,
      onTogglePopup,
    } = this.props;

    const bufferAmtView = (isBalanceLoaded)
      ? <CardBalance
          amount={bufferAmount}
          text="Balance"
          amountClassName="AddCouponPage_bufferAmt_amount"
          textClassName="AddCouponPage_bufferAmt_text"
        />
      : <LoadingSpinner style={{
          color: '#212121',
          marginBottom: '1rem'
        }} />
    const progressCircleBufferAmt = (isBalanceLoaded)
      ? bufferAmount
      : 0;

    return (
      <div>
        {/* Display Flex to space out content */}
        <FullPageLayout
          className="center-content-vertically"
          style={{
            justifyContent: 'space-between',
            padding: '1rem 0'
          }}
        >

          {/* Close Button - top right X */}
          <CloseAccountPage />

          {/* Keep these items grouped together */}
          <div>
            {/* Buffer Amount */}
            {bufferAmtView}

            <ProgressCircles
              bufferAmount={progressCircleBufferAmt}
              tiers={[1, 3, 6, 9]}
            />

            <div>
              <ShopriteCard className="AddCouponPage_shopriteCard" />
              <div className="AddCouponPage_cardAmt_text">
                Card Number: {cardNumber}
              </div>

              {/* Lifetime Earnings */}
              {/* <div className="AccountPage_cardAmt_text">
                ${toTwoDecimalPlaces(lifetimeAmount)} lifetime savings
              </div> */}
            </div>

            {/* "Add to Card" Button */}
            {!addBtnDisabled && isBalanceLoaded && (
              <div style={{margin: '1rem 0'}}>
                <LoyaltyButton
                  disabled={addBtnDisabled}
                  onClick={() => onAddBtnClick(goalAmount)}
                >
                  ADD ${goalAmount} TO YOUR CARD
                </LoyaltyButton>
              </div>
            )}
          </div>

          {/* Flex Spacer */}
          <div style={{height: '1px'}}></div>

          <div>
            <HowDoesThisWorkPopUp
              isOpen={isPopupOpen}
              onTogglePopup={onTogglePopup}
            />

            <LegalLinks style={{paddingTop: '1rem'}} />
          </div>
        </FullPageLayout>
      </div>
    );
  }
}

export default AddCouponPage;



// WEBPACK FOOTER //
// ./src/pages/Account/containers/AddCouponPage/AddCouponPage.js